import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const TopBar = () => {
    return (
        <>
            <div className="container-fluid bg-light p-0">
                <div className="row gx-0 d-none d-lg-flex">
                    <div className="col-lg-8 px-5 text-start">
                    <div
                        className="h-100 d-inline-flex align-items-center border-start border-end px-3">
                        <small className="fa fa-phone-alt me-2" style={{ color: 'gold' }}></small>
                        <small>+233 244429129</small>
                    </div>
                    <div className="h-100 d-inline-flex align-items-center border-end px-3">
                        <small className="fas fa-envelope-open me-2" style={{ color: 'gold' }}></small>
                        <small>info@fairvision.org</small>
                    </div>
                    <div className="h-100 d-inline-flex align-items-center border-end px-3">
                        <small className="fas fa-clock me-2" style={{ color: 'gold' }}></small>
                        <small>Mon - Fri : 09 AM - 09 PM</small>
                    </div>
                    <div className="h-100 d-inline-flex align-items-center border-end px-3">
                        <small className="me-2" style={{ color: 'gold' }}><FaWhatsapp/></small>
                        <small >+233 266198452</small>
                    </div>
                    </div>
                    <div className="col-lg-4 px-5 text-end">
                    <div className="h-100 d-inline-flex align-items-center">
                        <a className="btn btn-square border-end border-start" href="">
                            <i className="fab fa-facebook-f"></i>
                        </a>
                        <a className="btn btn-square border-end" href="">
                            <i className="fab fa-twitter"></i>
                        </a>
                        <a className="btn btn-square border-end" href="">
                            <i className="fab fa-linkedin-in"></i>
                        </a>
                        <a className="btn btn-square border-end" href="">
                            <i className="fab fa-instagram"></i>
                        </a>
                    </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TopBar;